import { useEffect, useState } from 'react';

import { supabase } from '@/components/atomic-crm/providers/supabase/supabase';
import { MIN_ASSEMBLEIAS, type LanceResumo, type Segmento } from './lanceRanking';

/**
 * O resumo histórico de lance por grupo. Este arquivo tinha também a faixa
 * "Contemplação mais barata (motor…)" no topo do North IA — saiu em 25/09
 * (Rick: "não faz mais sentido no chat"); a recomendação do motor vive na
 * Contemplação e no Simulador.
 */

// Reexporta pra quem já importa daqui (a tela de Grupos usa a mesma régua).
export { MIN_ASSEMBLEIAS, type LanceResumo };

/**
 * O resumo HISTÓRICO de lance por grupo (média 12m, migration 99) — hoje serve
 * de referência rotulada (modal da página de Lances), não de recomendação.
 */
export const useLanceResumo = () => {
  const [porGrupo, setPorGrupo] = useState<Map<number, LanceResumo>>(new Map());

  useEffect(() => {
    let ativo = true;
    (async () => {
      // Duas leituras porque o segmento não está na view de lance: ela agrega
      // assembleias, e "automóvel ou imóvel" é cadastro do grupo.
      const [resumo, cadastro] = await Promise.all([
        supabase
          .from('servopa_group_lance_resumo')
          // '*' e não a lista: as colunas da 252 entram quando a migration
          // chega ao banco, sem quebrar a leitura antes disso.
          .select('*'),
        supabase.from('servopa_groups_enriched').select('group_number, segment'),
      ]);
      if (!ativo || !resumo.data) return;

      const segmentoDoGrupo = new Map<number, Segmento>(
        ((cadastro.data ?? []) as { group_number: string | number; segment: string | null }[])
          .filter((g) => g.segment === 'M' || g.segment === 'I')
          .map((g) => [Number(g.group_number), g.segment as Segmento]),
      );

      setPorGrupo(
        new Map(
          (resumo.data as unknown as LanceResumo[]).map((l) => [
            l.group_number,
            { ...l, segment: segmentoDoGrupo.get(l.group_number) ?? null },
          ]),
        ),
      );
    })();
    return () => {
      ativo = false;
    };
  }, []);

  return porGrupo;
};
